import { Fragment, useState } from "react";

import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessDesignerToolbarModal from "./ProcessDesignerToolbarModal";
import ProcessDesignerDetailSetting from "./ProcessDesignerDetailSetting.js";

import { getLabel } from "../../tools/Dictionary";
import { MdArrowBackIosNew, MdHome, MdAdd, MdSettings } from "react-icons/md";

/*
Used by ProcessDesignerDetail
*/

const ProcessDesignerToolbar = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnClickHome = props.OnClickHome;
  const Component = props.Component;
  const Step = props.Step;
  const OnAddComponent = props.OnAddComponent;
  const OnEditStep = props.OnEditStep;
  const OnClickPrevious = props.OnClickPrevious;
  const OnDeleteStep = props.OnDeleteStep;



  //State
  const [modal, setModal] = useState(false);
  const [setting, setSetting] = useState(false); 
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onClickToolSetting = () =>
  {
    setSetting(setting => !setting);
  };

  
  const onClickToolModal = () => {
    setModal(modal => !modal);
  };


  const onAddComponent = (_component) => {

    OnAddComponent(_component);
    setModal(modal => !modal);
  };

  //() => OnClickPrevious(Step.path.length > 0 ? Step.path[Step.path.length - 1] : undefined)
  return (
    <Fragment>
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      {modal &&
        <ProcessDesignerToolbarModal
          IsDesktop={IsDesktop}
          Access={Access}
          OnCloseModal={onClickToolModal}
          Component={Component.filter(c => c.isAddable)}
          OnAddComponent={onAddComponent}
        />
      }
      {setting &&
        <ProcessDesignerDetailSetting
          IsDesktop={IsDesktop}
          Access={Access}
          ReadOnly={ReadOnly}
          OnCloseModal={onClickToolSetting}
          Step={Step}
          OnEditStep={OnEditStep}
          OnDeleteStep={OnDeleteStep}
          OnClickHome={OnClickHome}
        />
      }
      <div className="processdesigner_toolbar_button" style={{ top: (IsDesktop ? "10px" : "2px"), left: (IsDesktop ? "10px" : "2px")}} title={getLabel("ProcessDesigner", "Previous")}
        onClick={OnClickHome}
      >
        <MdArrowBackIosNew />
      </div>
      <div className="processdesigner_toolbar_button" style={{ top: (IsDesktop ? "10px" : "2px"), left: (IsDesktop ? "80px" : "60px") }} title={getLabel("ProcessDesigner", "Home")} 
        onClick={OnClickHome}>
        <MdHome />
      </div>
      <div className="processdesigner_toolbar_button" style={{ top: (IsDesktop ? "10px" : "2px"), right: (IsDesktop ? "90px" : "60px"), fontSize: "40px" }} title={getLabel("ProcessDesigner", "Settings")}
        onClick={onClickToolSetting}
      >
        <MdSettings />
      </div>
      {(Access.canWrite && !ReadOnly) &&
        <div className="processdesigner_toolbar_button" style={{ top: (IsDesktop ? "10px" : "2px"), right: (IsDesktop ? "20px" : "2px"), fontSize: "40px" }} title={getLabel("ProcessDesigner", "Add Component")}
          onClick={onClickToolModal}
        >
          <MdAdd />
        </div>
      }
    </Fragment>
  );

};

export default ProcessDesignerToolbar